import React from 'react';
import { ClockIcon } from 'lucide-react';
import { LateChange } from '../../types/commission';
import { Card } from '../sf/Card';
import { ExampleDataBadge } from '../sf/ExampleDataBadge';
import { Money } from '../sf/Money';
import { NewBadge } from '../sf/NewBadge';
interface LateChangesCardProps {
  changes: LateChange[];
  isLocked: boolean;
}
export function LateChangesCard({
  changes,
  isLocked
}: LateChangesCardProps) {
  return <Card title={`Late changes (${changes.length})`} icon={ClockIcon} iconBg="#FE9339" meta={isLocked ? 'Posted as Adjustment lines to November 2026' : 'Will post as Adjustment lines to November 2026 if locked'} bodyClassName="" actions={<>
          <NewBadge label="NEW" data-id="element-597" data-mp="110ov1w72vpq2" />
          <ExampleDataBadge data-id="element-598" data-mp="1oru8y5tgk7xq" />
        </>} data-id="element-596" data-mp="15trp05frp16s">
      <p className="border-t border-sf-border px-4 py-2 text-xs text-sf-weak" data-id="element-599" data-mp="1or2ckss1e66e">
        Estimate – final Adjustment lines are calculated on the Adjusted Loan Amount when posted. Today a post-funding loan edit silently rewrites the original month’s fee.
      </p>
      <ul className="divide-y divide-sf-border border-t border-sf-border" data-id="element-600" data-mp="1mwuynyxlcwg7">
        {changes.map(change => <li key={change.id} className="grid grid-cols-[minmax(0,1fr)_auto] gap-x-4 px-4 py-2.5" data-id="element-601" data-mp="20o9ha4nl6vmq">
            <div className="min-w-0" data-id="element-602" data-mp="1vx1736efn68i">
              <p className="text-[13px]" data-id="element-603" data-mp="1vvzv8zplefpq">
                <span className="font-semibold text-sf-blue" data-id="element-604" data-mp="2alxer2ckuh8l">{change.loanNumber}</span>
                <span className="text-sf-weak" data-id="element-605" data-mp="25n2xi4u9d0ql"> · {change.borrower} · {change.loanOfficer}</span>
              </p>
              <p className="text-[13px] tabular-nums" data-id="element-606" data-mp="2jmluq2lj6ro4">
                {change.field}: <span className="text-sf-weak line-through" data-id="element-607" data-mp="2jkj4bhgguwiv">{change.from}</span>
                <span className="mx-1 text-sf-weak" data-id="element-608" data-mp="2fm1ugq5nv7xr">→</span>
                <span className="font-semibold" data-id="element-609" data-mp="p82pvtdioc2x">{change.to}</span>
              </p>
              <p className="text-xs tabular-nums text-sf-weak" data-id="element-610" data-mp="l7isqpsy18gs">{change.impactDetail}</p>
              <p className="text-xs text-sf-weak" data-id="element-611" data-mp="2kc0rzbtpwe6a">Edited after last calculation</p>
            </div>
            <div className="text-right" data-id="element-612" data-mp="2pb3y6zlfoqfu">
              <p className="text-xs text-sf-weak" data-id="element-613" data-mp="2pbvgj8q0sro6">Estimate</p>
              <p className="font-semibold" data-id="element-614" data-mp="2uagibckx7jeq">
                <Money value={change.estImpact} signed data-id="element-615" data-mp="2u9dooww7r2v4" />
              </p>
            </div>
          </li>)}
      </ul>
    </Card>;
}